import mixpanel from 'mixpanel-browser';

import * as graphql from '@treams/treams-network';

import { useFeature } from './useFeature';
import { useViewer } from './useViewer';
import { useWorkspace } from './useWorkspace';

export function useMixpanel(): typeof mixpanel | undefined {
	const workspace = useWorkspace();

	const enabled = useFeature(graphql.FeatureName.Analytics);
	const user = useViewer();

	if (!import.meta.env.VITE_MIXPANEL_API_TOKEN) {
		return undefined;
	}

	if (workspace.id === 'try' || location.pathname === '/try') {
		return mixpanel;
	}

	return enabled && user?.allowsUsageStatistics ? mixpanel : undefined;
}
